import SEO from "@/components/SEO";
import { Reveal } from "@/components/motion/Reveal";
import { Eyebrow } from "@/components/primitives";
import PilotCard from "@/components/sections/PilotCard";

export default function DiscoveryChooser() {
  return (
    <>
      <SEO
        title="Book a Discovery Call | Green Circle Group"
        description="Book a complimentary 30-minute Discovery Call for the Energy Growth Pilot or the Installer Growth Pilot."
        path="/discovery"
        noindex
      />

      <section
        data-testid="discovery-chooser"
        className="relative bg-white pt-28 md:pt-36 pb-24 min-h-screen"
      >
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          <Reveal>
            <div className="text-center">
              <Eyebrow className="justify-center">
                Book a Discovery Call
              </Eyebrow>
              <h1 className="mt-5 text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight leading-[1.08] text-forest text-balance">
                Which pilot would you like to chat about?
              </h1>
              <p className="mt-4 text-mid-neutral leading-relaxed max-w-xl mx-auto">
                Pick the pilot that best matches how your business operates
                today — you&apos;ll book a 30-minute chat with the Green Circle Group
                team.
              </p>
            </div>
          </Reveal>

          <div className="mt-12 grid md:grid-cols-2 gap-5">
            <Reveal>
              <PilotCard
                label="Energy Growth Pilot"
                title="For solar, battery & home-energy retailers"
                description="A four-week Meta campaign to prove lead quality and conversion for retailers with their own sales team."
                ctaLabel="Book Energy Growth Pilot chat"
                ctaTo="/discovery/energy-growth-pilot"
                testId="chooser-egp"
              />
            </Reveal>
            <Reveal delay={0.08}>
              <PilotCard
                label="Installer Growth Pilot"
                title="For solar & battery installers"
                description="A four-week lead-to-installation-ready sales pilot for installers building a direct pipeline under their own brand."
                ctaLabel="Book Installer Growth Pilot chat"
                ctaTo="/discovery/installer-growth-pilot"
                variant="dark"
                testId="chooser-igp"
              />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
